var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "slidePage" }, [
    _c(
      "div",
      { staticClass: "white_layer" },
      [
        _c(
          "el-carousel",
          {
            ref: "nop",
            attrs: {
              arrow: "never",
              height: "106px",
              autoplay: _vm.type,
              "indicator-position": _vm.auditList.length > 1 ? "" : "none"
            }
          },
          _vm._l(_vm.auditList, function(item, index) {
            return _c(
              "el-carousel-item",
              { key: index, staticClass: "el_carousel__item_style" },
              [
                _c(
                  "v-touch",
                  {
                    staticClass: "wrapper",
                    attrs: { "swipe-options": { direction: "horizontal" } },
                    on: {
                      swipeleft: function($event) {
                        return _vm.swiperleft(index)
                      },
                      swiperight: function($event) {
                        return _vm.swiperright(index)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "demo-image" },
                      _vm._l(item.billName, function(nameshow, number) {
                        return _c(
                          "div",
                          { key: number, staticClass: "block" },
                          [
                            _c("el-image", {
                              staticStyle: { width: "42px", height: "42px" },
                              attrs: { src: item.url[number] },
                              on: {
                                click: function($event) {
                                  return _vm.auditClick(item.entityId[number])
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "demonstration" }, [
                              _vm._v(_vm._s(nameshow))
                            ])
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ]
                )
              ],
              1
            )
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }